import React, { Component } from "react"
import { withRouter, Link } from "react-router-dom"
import * as ApiHelper from "../../../ApiHelper"
import Moment from "moment"
import { TableLayout } from "../../../components"
import { LoadModal } from "../../modais"
import { ToastContainer, ToastMessage } from "react-toastr"
import Truncate from "react-truncate"
import { confirmAlert } from "react-confirm-alert"
class TableNotificacao extends Component {
  constructor() {
    super()
    this.toastFactory = React.createFactory(ToastMessage.animation)
    this.delete = this.delete.bind(this)
    this.getSolicitacaoPendencias = this.getSolicitacaoPendencias.bind(this)
    this.toggleLoadModal = this.toggleLoadModal.bind(this)
    this.state = {
      showLoad: false
    }
  }
  addAlert(title, message) {
    this.container.error(title, message, {
      timeOut: 5000,
      extendedTimeOut: 3000
    })
  }
  delete(id) {
    confirmAlert({
      title: "Confirme a remoção",
      message: "Tem certeza que deseja deletar?",
      buttons: [
        {
          label: "Sim",
          onClick: () =>
            ApiHelper.deleteSolicitacao(id, error => {
              if (error) {
                this.addAlert("", error.message)
              } else {
                this.props.onDelete()
              }
            })
        },
        {
          label: "Não"
        }
      ]
    })
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad
    })
  }
  getSolicitacaoPendencias(event, id) {
    this.toggleLoadModal()
    ApiHelper.printSolicitacao(id, (ficha, error) => {
      this.toggleLoadModal()
      if (ficha) {
        var url = URL.createObjectURL(ficha)
        var tempLink = document.createElement("a")
        tempLink.href = url
        tempLink.setAttribute("download", "Notificação:" + id + ".pdf")
        document.body.appendChild(tempLink)
        tempLink.click()
        document.body.removeChild(tempLink)
      } else {
        this.addAlert("", error.message)
      }
    })
  }
  render() {
    var buttons = [
      {
        title: "Criar Notificação",
        link: "/solicitacaoesclarecimento/create",
        icon: "control_point"
      },
      {
        title: "Notificações deletadas",
        link: "/solicitacaoesclarecimento/trash",
        icon: "delete"
      }
    ]
    return (
      <div>
        <ToastContainer
          ref={input => {
            this.container = input
          }}
          toastMessageFactory={this.toastFactory}
          className="toast-top-right"
          preventDuplicates={true}
        />
        <LoadModal onClose={this.toggleLoadModal} show={this.state.showLoad} />
        <TableLayout
          headerButtons={buttons}
          sizeClass={this.props.sizeClass}
          backgroundColor={this.props.backgroundColor}
          title={this.props.title}
          subtitle={this.props.subtitle}
          filter={this.props.filter}
          searchLabel="Pesquisar Notificações"
        >
          {this.props.rows.map((row, key) => {
            return (
              <div key={key} className="col-md-4">
                <div className="card container" style={{ minHeight: 330 }}>
                  <div
                    className="card-header"
                    data-background-color={this.props.backgroundColor}
                  >
                    <h4 className="title text-center col-md-offset-right-1">
                      {"Contrato Nº " + row.contrato.num_contrato}
                    </h4>
                    <p className="category text-center col-md-offset-right-1">
                      {"Criado em " + Moment(row.created_at).format("D/MM/Y")}
                    </p>
                  </div>
                  <div className="card-body">
                    <table
                      className="table table-hover"
                      style={{ tableLayout: "fixed" }}
                    >
                      <thead className="text-warning">
                        <tr>
                          <th>Pendência</th>
                          <th>Referência</th>
                        </tr>
                      </thead>
                      <tbody>
                        {row.pendencias
                          .slice(0, 4)
                          .map((pendencia, pendenciaKey) => {
                            return (
                              <tr key={pendenciaKey}>
                                <td>
                                  <Truncate lines={1}>
                                    {pendencia.pendencia}
                                  </Truncate>
                                </td>
                                <td>
                                  <Truncate lines={1}>
                                    {pendencia.ref_contratual}
                                  </Truncate>
                                </td>
                              </tr>
                            )
                          })}
                      </tbody>
                    </table>
                    <div className="col-md-12">
                      <div className="col-md-2 col-md-offset-3">
                        <Link
                          style={{ padding: "unset" }}
                          title="Editar notificação"
                          className="btn btn-primary btn-simple"
                          to={"solicitacaoesclarecimento/edit/" + row.id}
                        >
                          <i className="material-icons">edit</i>
                        </Link>
                      </div>
                      <div className="col-md-2">
                        <button
                          style={{ padding: "unset" }}
                          type="button"
                          rel="tooltip"
                          title="Remover notificação"
                          onClick={() => this.delete(row.id)}
                          className="btn btn-danger btn-simple"
                        >
                          <i className="material-icons">close</i>
                        </button>
                      </div>
                      <div className="col-md-2">
                        <button
                          style={{ padding: "unset" }}
                          type="button"
                          onClick={event =>
                            this.getSolicitacaoPendencias(event, row.id)
                          }
                          rel="tooltip"
                          title="Imprimir notificação"
                          className="btn btn-info btn-simple btn-xs"
                        >
                          <i className="material-icons">print</i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          })}
        </TableLayout>
      </div>
    )
  }
}
export default withRouter(TableNotificacao)



// WEBPACK FOOTER //
// ./src/views/fiscalizacao/notificacao/TableNotificacao.js